import { createContext } from 'react';

export const TableContext = createContext(null)

export const UserProfile = createContext(null)

export const SystemTypeContext = createContext(null)
